import { withSentry } from '../modules/sentry';
import $dom from 'cash-dom';
import homepageCarousel from '../modules/homepage_carousel';

$dom(document).ready(
  withSentry(() => {
    homepageCarousel();
  })
);
